import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Box, Grid, Typography, Button, TextField
} from '@mui/material';
import { postTelematicsActivityData, getTelematicsActivityData, getTelematicsActivityDataForEquipment } from '../../../../actions/tigercat-burns/tigercat-actions';
import { getCompanyBiocharEquipment } from '../../../../actions/tigercat-burns/tigercat-base-actions';
import TelematicsActivityDataTable from './TelematicsActivityDataTable';

export const TelematicsActivityData = ({ activeCarRppb, activeCarRppbProject }) => {
    const dispatch = useDispatch();
    const equipment_data = useSelector(state => state.tigercatBurnsReducer.telematicsActivityData?.data?.equipment_data);
    const telematics_data = useSelector(state => state.tigercatBurnsReducer.telematicsActivityData?.data?.telematics_data);
    const { userData } = useSelector(state => state.auth);
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadSuccess, setUploadSuccess] = useState(false); // State variable to trigger re-render
    const userCompanyId = userData?.tigercatBurnsUser?.companyId;

    useEffect(() => {
        if (activeCarRppbProject) {
            dispatch(getTelematicsActivityData(activeCarRppbProject.id, userCompanyId, 10, 0));
            dispatch(getCompanyBiocharEquipment(userCompanyId));
        }
    }, [dispatch, activeCarRppbProject, uploadSuccess]); // Add uploadSuccess to the dependency array

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const handleUploadCsv = (carRppb, carRppbProject, equipmentId) => {
        if (selectedFile) {
            const formData = new FormData();
            formData.append('file', selectedFile);

            dispatch(postTelematicsActivityData(carRppbProject.id, equipmentId, formData, 10, 0)).then(() => {
                console.log('CSV upload success');
                // Reset pagination to page 1
                // handlePageOrRowsChange(equipmentId, 10, 1)
                setUploadSuccess(!uploadSuccess); // Toggle the state variable to trigger re-render
            });
        }
    };

    const handlePageOrRowsChange = (equipmentId, rowsPerPage, currentPage) => {
        dispatch(getTelematicsActivityDataForEquipment(activeCarRppbProject.id, equipmentId, rowsPerPage, currentPage));
    };

    return (
        <>
            {activeCarRppbProject && (
                <Grid container>
                    <Grid item sm={12}>
                        <Typography variant='h5' component='h4' sx={{ mb: 2.5 }}>
                            Telematics Activity Data
                        </Typography>

                        {equipment_data?.map((e) => {
                            const telematicsEntries = telematics_data?.[e.id]?.data || [];
                            const pagination = telematics_data?.[e.id]?.pagination || {};

                            return (
                                <Box key={e.id} sx={{ mb: 4 }}>
                                    <TextField
                                        sx={{ mb: 2 }}
                                        type="file"
                                        onChange={handleFileChange}
                                    />

                                    <Button
                                        sx={{ display: 'block', mb: 2 }}
                                        variant='contained'
                                        color='primary'
                                        onClick={() => handleUploadCsv(activeCarRppb, activeCarRppbProject, e.id)}
                                    >
                                        Upload CSV for {e?.name}
                                    </Button>

                                    {telematicsEntries.length > 0 && (
                                        <TelematicsActivityDataTable
                                            key={uploadSuccess}
                                            uploadSuccess={uploadSuccess}
                                            handleUploadCsv={handleUploadCsv}
                                            equipment={e}
                                            entries={telematicsEntries}
                                            activeCarRppb={activeCarRppb}
                                            activeCarRppbProject={activeCarRppbProject}
                                            pagination={{ ...pagination }}
                                            handlePageOrRowsChange={(rowsPerPage, currentPage) => handlePageOrRowsChange(e.id, rowsPerPage, currentPage)}
                                        />
                                    )}
                                </Box>
                            );
                        })}
                    </Grid>
                </Grid>
            )}
        </>
    );
};